// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3cCfw","header":"MessagesList_header__1uP2c","chat":"MessagesList_chat__171-5"};